// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    Avatar,
    // Button,
    // Card,
    // CardContent,
    Chip,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Link,
    Typography
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
// assets
// import { IconBrandTelegram, IconBuildingStore, IconMailbox, IconPhoto } from '@tabler/icons';
import { NotificationProps } from 'types/notifications';
import { formatDate } from 'views/utilities/format';
import { setRead, setOpen } from 'store/slices/notification';
import { dispatch, useSelector } from 'store';
// import { DefaultRootStateProps } from 'types';
import { ROUTE_NAME } from 'configs';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    marginBottom: 3,
    position: 'relative',
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

const NotificationList = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { notifications } = useSelector((state) => state.notification);
    const navigate = useNavigate();
    const handleRead = (item: NotificationProps) => {
        if (!item.is_read) {
            dispatch(setRead(item.id.toString()));
        }
        navigate(`${ROUTE_NAME.complaint.view}/${item.ticket_id}`);
        dispatch(setOpen(false));
    }
    return (
        <List
            sx={{
                width: '100%',
                maxWidth: 330,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 300
                },
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {notifications && notifications?.map((item: NotificationProps, index: number) => (
                <ListItemWrapper key={item.id}
                >
                    <ListItem
                        alignItems="center"
                        onClick={() => handleRead(item)}
                    >
                        <ListItemAvatar>
                            <Avatar alt="Bot" src="/assistant.png" />
                        </ListItemAvatar>
                        <ListItemText primary={t(item.title)} />
                        {/* <ListItemSecondaryAction>
                            <Grid container justifyContent="flex-end">
                                <Grid item xs={12}>
                                    <Typography variant="overline" display="block" gutterBottom>
                                        {formatDate('', item.created_at)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </ListItemSecondaryAction> */}
                    </ListItem>
                    <Grid container direction="column" className="list-container">
                        <Grid item xs={12} sx={{ pb: 2 }}>
                            <Typography variant="caption" color="inherit">
                                {`${t(item.description)}`}
                                <Link
                                    component={RouterLink} to={`${ROUTE_NAME.complaint.view}/${item.ticket_id}`}
                                    underline="hover"
                                    rel="noreferrer"
                                    onClick={() => dispatch(setOpen(false))}
                                >{`${item.ticket_code}`}</Link>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="flex-end">
                        <Grid item xs={12}>
                            <Typography variant="overline" display="block" textAlign="right">
                                {formatDate('', item.created_at)}
                            </Typography>
                        </Grid>
                    </Grid>
                    {index < notifications.length - 1 && (
                        <Divider />
                    )}
                    {item.is_read === 0 && (
                        <Stack sx={{
                            width: "60px",
                            height: "20px",
                            position: "absolute",
                            top: "0px",
                            right: "-5px",
                            background: "red",
                            textAlign: "center",
                            borderRadius: "10px",
                            fontSize: ".7rem",
                            transform: "rotate(20deg)",
                        }}>
                            <Chip label="New" sx={{ color: "#fff" }} />
                        </Stack>
                    )}
                </ListItemWrapper>
            ))}
        </List>
    );
};

export default NotificationList;
